import { c as _c } from "react/compiler-runtime";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { NetworkError } from "@/components/uis/NetworkError";
import { useConnectionCheckPollingForSnackbar } from "@/hooks/utils/connection-check/useConnectionCheckPollingForSnackbar";
import { makeSequentialComponent as makeSC } from "@/utils/sequential-component";
const checkOnline = async () => {
  const isOnline = navigator.onLine;
  if (!isOnline) {
    throw new Error("Network is not available");
  }
  return {
    isOnline
  };
};

/**
 * ネットワークエラーチェック付きのラッパーコンポーネント
 * childrenをそのまま表示し、ネットワークエラー時はSnackbarを表示する
 */
const NetworkCheckInner: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(15);
  const {
    children
  } = t0;
  const {
    open,
    setOpen
  } = useConnectionCheckPollingForSnackbar();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      vertical: "bottom",
      horizontal: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== setOpen) {
    t2 = () => setOpen(false);
    $[1] = setOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== setOpen) {
    t3 = () => setOpen(false);
    $[3] = setOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      w: "100%",
      mb: "8px"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <Alert onClose={t3} severity="error" sx={t4}>ネットワークが不安定です</Alert>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== open || $[9] !== t2 || $[10] !== t5) {
    t6 = <Snackbar anchorOrigin={t1} open={open} autoHideDuration={5000} onClose={t2}>{t5}</Snackbar>;
    $[8] = open;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== children || $[13] !== t6) {
    t7 = <>{children}{t6}</>;
    $[12] = children;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
const NetworkCheckWrapper = makeSC(checkOnline)(NetworkCheckInner, NetworkError);
export { NetworkCheckWrapper };